import { get } from "utils/request"
import { isMobile } from "../utils/utils"

export async function getshoplink() {
  const source =  isMobile() ? 'h5' : 'pc'
  const referrer = window.location.host.includes('localhost') ? 'https://test-site.tikvpn.in' : window.location.origin
  const data = await get(`/shop/links?source=${source}&referrer=${referrer}`, {})
  return data
}
